import { Tooltip, Typography } from "@mui/material"
import { useState } from "react"

export const DoiButton = ({ doi }) => {
    const [copiedDOI, setCopiedDOI] = useState(null)

    const handleCopyDoi = async (doiValue) => {
        try {
            const doiUrl = doiValue.startsWith("https://doi.org/")
                ? doiValue
                : `https://doi.org/${doiValue}`
            await navigator.clipboard.writeText(doiUrl)
            setCopiedDOI(doiValue)
            setTimeout(() => setCopiedDOI(null), 1000)
        }
        catch (error) {
            console.error("Failed to copy DOI:", error)
        }
    }

    if (!doi || doi === null) return null
    return (<Tooltip title="Copy DOI" arrow>
        <Typography variant="caption" onClick={() => handleCopyDoi(doi)}
            sx={{
                cursor: "pointer",
                backgroundColor: "#E5E4E2",
                color: "#808080",
                padding: "2px 8px",
                borderRadius: "4px",
                display: "inline-block",
                "&:hover": {
                    backgroundColor: "#D3D3D3",
                    fontWeight: 500,
                },
            }}>
            {copiedDOI === doi ? "DOI Copied!" : "DOI"}
        </Typography>
    </Tooltip>)
}